export default "__VITE_ASSET__BQe4YCOU__"